import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=1a2c651e"
import script from "./CreateTicket.vue?vue&type=script&lang=ts"
export * from "./CreateTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports